import React from 'react';
import ListTable from './components/ListTable';
import { Accordion, AccordionDetails, withStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';

const AccordionSummary = withStyles({
  root: {
    minHeight: 56,
    borderRadius: '8px',
    transition: 'all 0.2s ease',
    '&$expanded': {
      minHeight: 56,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    },
    '&:hover': {
      backgroundColor: 'rgba(233, 236, 239, 0.8)'
    }
  },
  content: {
    margin: '12px 0',
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

export const ListView = ({
  data,
  slaColumnInfo,
  customFields,
  handleUpdate,
  handleCall,
  disableClickToCall,
  protocolDefaultFieldsDisplaySettings,
  status,
  stagePageInfo,
  onTableGrow
}) => {
  const protocolsByStatus = React.useMemo(() => {
    const protocols = {};

    status.forEach((statusItem) => {
      protocols[statusItem.id] = [];
    });

    data.forEach((item) => {
      if (item.protocols && Array.isArray(item.protocols)) {
        item.protocols.forEach((protocol) => {
          const statusId = protocol.current_status;
          if (protocols[statusId]) {
            protocols[statusId].push(protocol);
          }
        });
      }
    });

    return protocols;
  }, [data, status]);

  const render = () => {
    return (
      <div style={{ padding: '16px', backgroundColor: '#f7f9fb' }}>
        {status.map((statusItem) => {
          const protocols = protocolsByStatus[statusItem.id] || [];
          const stage = stagePageInfo.find((data) => data.id === statusItem.id);

          return (
            <div
              key={statusItem.id}
              style={{
                marginBottom: '12px',
                transition: 'all 0.2s ease'
              }}
            >
              <Accordion
                defaultExpanded
                style={{
                  border: 'none',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                  borderRadius: '8px',
                  backgroundColor: 'white'
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      style={{
                        color: '#6B7280',
                        transition: 'transform 0.2s ease'
                      }}
                    />
                  }
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    background: 'white',
                    borderLeft: `4px solid ${statusItem.color}`,
                    borderRadius: '8px'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      padding: '4px 8px'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1
                      }}
                    >
                      <span
                        style={{
                          fontSize: '15px',
                          fontWeight: 600,
                          color: '#1F2937'
                        }}
                      >
                        {statusItem.name}
                      </span>
                      <div
                        style={{
                          minWidth: '28px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#F3F4F6',
                          borderRadius: '10px',
                          padding: '0 8px',
                          marginLeft: '12px',
                          fontSize: '13px',
                          fontWeight: 500,
                          color: '#4B5563'
                        }}
                      >
                        {data.find((item) => item.id === statusItem.id)
                          ?.count || 0}
                      </div>
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    padding: '16px',
                    backgroundColor: 'white',
                    borderBottomLeftRadius: '8px',
                    borderBottomRightRadius: '8px'
                  }}
                >
                  <ListTable
                    customFields={customFields}
                    data={protocols}
                    handleUpdate={handleUpdate}
                    handleCall={handleCall}
                    disableClickToCall={disableClickToCall}
                    protocolDefaultFieldsDisplaySettings={
                      protocolDefaultFieldsDisplaySettings
                    }
                    stagePageInfo={stage}
                    stageId={statusItem.id}
                    onTableGrow={onTableGrow}
                    slaColumnInfo={slaColumnInfo}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })}
      </div>
    );
  };

  return render();
};

export default ListView;
